import {cva} from 'class-variance-authority'

// v3 "filled" field: bottom-border only, top corners rounded, mint fill.
export const inputTextFieldVariants = cva(
  'flex w-full items-center gap-1 rounded-t-[4px] border-b border-solid px-3 py-2 transition-colors focus-within:border-primary',
)

export const inputIconWrapperClass =
  'flex shrink-0 items-center justify-center min-w-4 min-h-4 whitespace-nowrap text-text-secondary [&_svg]:size-4'

export const inputBaseClass =
  'flex-1 bg-transparent outline-none text-base font-semibold text-text-secondary placeholder:text-text-disabled disabled:text-text-disabled focus:text-text-primary'
